/** Display logic shared by the "My Life Story" (ethical will) story screen and
 * the keepsake PDF builder. Plain JS only: this module is imported by both the
 * dashboard (browser React) and the databot server (Node string templates), so
 * it must not pull in React, Immutable, or DOM APIs.
 */

export const storyCountLabel = count => `${count} ${count === 1 ? 'story' : 'stories'}`

/** e.g. "3 stories" — used in the PDF table of contents. */
export const chapterCountLabel = ({storyCount}) => storyCountLabel(storyCount)

/** e.g. "as told by Andrea Johnson" — the byline under the story title. */
export const storyDateline = ownerName => `as told by ${ownerName}`

/** e.g. "1:12" — duration label for voice recordings. The value crosses a
 * service boundary, so anything non-numeric degrades to 0:00 instead of
 * rendering "NaN:NaN".
 */
export const formatDuration = seconds => {
  const numericSeconds = Number(seconds)
  const safeSeconds = Number.isFinite(numericSeconds) ? Math.max(0, Math.floor(numericSeconds)) : 0

  return `${Math.floor(safeSeconds / 60)}:${`0${safeSeconds % 60}`.slice(-2)}`
}

/**
 * Splits free-typed answer text into paragraphs: blank lines separate
 * paragraphs, single newlines survive inside a paragraph (consumers render
 * them as line breaks). Normalizes Windows/old-Mac newlines first.
 */
export const paragraphsFromText = text => String(text || '')
  .replace(/\r\n?/g, '\n')
  .split(/\n{2,}/)
  .map(block => block.trim())
  .filter(Boolean)
